<template>
  <v-container fluid class="fill-height grey lighten-4">
    <v-row no-gutters justify="center" align="center">
      <v-card outlined width="350" elevation="1">

        <v-toolbar tile flat color="primary">
          <v-toolbar-title class="white--text">
            ATHENA
          </v-toolbar-title>
        </v-toolbar>

        <v-card-text class="pa-4 pt-8">
          <v-row align="center" justify="center">
            <v-avatar color="primary" size="150">
              <v-icon color="white" size="75" v-text="`mdi-lock`"/>
            </v-avatar>
          </v-row>
        </v-card-text>

        <v-card-text>

          <v-form lazy-validation ref="form">
            <v-text-field
              v-model="user.email"
              :rules="rules.email"
              @keypress.enter="doLogin"
              placeholder="Email"
              autocomplete="email"
              name="email"
              outlined
              dense
              type="text"
            />
            <v-text-field
              v-model="user.password"
              :rules="rules.password"
              :type="show ? 'text' : 'password'"
              :append-icon="show ? 'mdi-eye-off' : 'mdi-eye'"
              @click:append="show = !show"
              @keypress.enter="doLogin"
              placeholder="Password"
              autocomplete="password"
              name="password"
              outlined
              dense
            />
          </v-form>

        </v-card-text>

        <v-divider class="mx-4 mt-n2"/>

        <v-card-text>
          <v-row dense>
            <v-col cols="12">
              <v-btn block depressed large color="primary" @click="doLogin" :disabled="account.status.working" :loading="account.status.working">Login</v-btn>
            </v-col>
          </v-row>
<!--          <v-row dense>-->
<!--            <v-col cols="12">-->
<!--              <v-btn block outlined color="primary" @click="doRegister">Register</v-btn>-->
<!--            </v-col>-->
<!--          </v-row>-->
<!--          <v-row dense no-gutters align="center" justify="center">-->
<!--            <router-link class="mt-3" to="/authentication/recover-password">-->
<!--              <a>Forgot password?</a>-->
<!--            </router-link>-->
<!--          </v-row>-->
        </v-card-text>

      </v-card>
    </v-row>
  </v-container>
</template>

<script>

  import {mapGetters, mapActions} from 'vuex'

  export default {
    data: () => ({
      show: false,
      user: {
        email: null,
        password: null
      },
      rules: {
        email: [
          (v) => !!v || 'Email is required.',
          (v) => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'Email must be valid.'
        ],
        password: [
          (v) => !!v || 'Password is required.'
        ]
      },
    }),

    computed: {
      ...mapGetters('account', ['account']),
    },

    methods: {

      ...mapActions('account', ['login']),

      doLogin() {
        if (this.$refs.form.validate()) {
          this.login({email: this.user.email, password: this.user.password});
        }
      },

      doRegister() {
        this.$router.push({path: '/authentication/register'})
      }

    }
  }

</script>

<style>
  #login input,
  input:-webkit-autofill,
  input:-webkit-autofill:hover,
  input:-webkit-autofill:focus {
    -webkit-box-shadow: 0 0 0 30px white inset;
  }
</style>
